import api from '../React/Helpers/api';

const baseUrl = () => window.SiteConfig.baseUrl;

const unwrap = (request) => request.then((response) => response.data);

export const addItem = ({productId, unit, count, special, cleanCart}) =>
    unwrap(api.post(`${baseUrl()}/bestellen/winkelwagen/item`, {
        product_id: productId,
        unit,
        count,
        special: special == 1 || special === true,
        cleanCart,
    }));

export const addDirect = ({productId, unitCode, count, special, cleanCart}) =>
    unwrap(api.post(`${baseUrl()}/bestellen/winkelwagen/direct`, {
        product_id: productId,
        unit_code: unitCode,
        count,
        special,
        cleanCart,
    }));

export const updateItem = (itemId, {productId, unitCode, count}) =>
    unwrap(api.put(`${baseUrl()}/bestellen/winkelwagen/item/${itemId}`, {
        product_id: productId,
        unit_code: unitCode,
        count,
    }));

export const deleteItem = (itemId) =>
    unwrap(api.post(`${baseUrl()}/bestellen/winkelwagen/delete-item`, {
        id: itemId,
    }));

export const repeatOrder = (orderId) =>
    unwrap(api.post(`${baseUrl()}/bestellen/winkelwagen/repeat-order`, {
        order_id: orderId,
    }));

export const quotationOrder = (quotationId) =>
    unwrap(api.post(`${baseUrl()}/bestellen/winkelwagen/quotation-order`, {
        quotation_id: quotationId,
    }));

export const requestQuotationPrice = ({quotationId, email, firstname, lastname, username}) =>
    unwrap(api.post(`${baseUrl()}/ajax/request-quotation-price`, {
        quotation_id: quotationId,
        email,
        firstname,
        lastname,
        username,
    }));

export default {
    addItem,
    addDirect,
    updateItem,
    deleteItem,
    repeatOrder,
    quotationOrder,
    requestQuotationPrice,
};
